<div
  class="min-h-screen bg-[#F9F8F7] p-4 font-poppins"
  id="ngo-diligence-content"
>
  <div class="max-w-7xl mx-auto">
    <!-- Loading State - Skeleton -->
    <div *ngIf="loading" class="space-y-6 animate-pulse">
      <!-- Top Header Section Skeleton -->
      <div class="bg-white rounded-lg shadow-sm p-6">
        <div
          class="flex flex-col md:flex-row justify-between items-start gap-4"
        >
          <div class="space-y-3 flex-1">
            <div class="flex items-center gap-2">
              <div class="h-6 w-6 bg-gray-200 rounded-full"></div>
              <div class="h-6 w-40 bg-gray-200 rounded"></div>
            </div>
            <div class="space-y-2">
              <div class="h-4 w-64 bg-gray-200 rounded"></div>
              <div class="h-4 w-48 bg-gray-200 rounded"></div>
            </div>
          </div>
          <div class="flex items-center gap-3">
            <div class="h-10 w-24 bg-gray-200 rounded"></div>
            <div class="h-10 w-24 bg-gray-200 rounded"></div>
          </div>
        </div>
      </div>

      <!-- Certificate Banner Skeleton -->
      <div class="bg-gray-200 rounded-lg shadow-sm p-8 h-32"></div>

      <!-- Created Date Skeleton -->
      <div class="h-5 w-48 bg-gray-200 rounded"></div>

      <!-- Organization Info Card Skeleton -->
      <div class="bg-white rounded-lg shadow-sm p-6 space-y-4">
        <div class="h-6 w-48 bg-gray-200 rounded"></div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="space-y-2">
            <div class="h-4 w-32 bg-gray-200 rounded"></div>
            <div class="h-4 w-full bg-gray-200 rounded"></div>
          </div>
          <div class="space-y-2">
            <div class="h-4 w-32 bg-gray-200 rounded"></div>
            <div class="h-4 w-full bg-gray-200 rounded"></div>
          </div>
        </div>
      </div>

      <!-- Compliance Cards Skeleton -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="bg-white rounded-lg shadow-sm p-6 space-y-4">
          <div class="h-6 w-40 bg-gray-200 rounded"></div>
          <div class="space-y-2">
            <div class="h-4 w-full bg-gray-200 rounded"></div>
            <div class="h-4 w-3/4 bg-gray-200 rounded"></div>
            <div class="h-4 w-1/2 bg-gray-200 rounded"></div>
          </div>
        </div>
        <div class="bg-white rounded-lg shadow-sm p-6 space-y-4">
          <div class="h-6 w-40 bg-gray-200 rounded"></div>
          <div class="space-y-2">
            <div class="h-4 w-full bg-gray-200 rounded"></div>
            <div class="h-4 w-3/4 bg-gray-200 rounded"></div>
            <div class="h-4 w-1/2 bg-gray-200 rounded"></div>
          </div>
        </div>
        <div class="bg-white rounded-lg shadow-sm p-6 space-y-4">
          <div class="h-6 w-40 bg-gray-200 rounded"></div>
          <div class="space-y-2">
            <div class="h-4 w-full bg-gray-200 rounded"></div>
            <div class="h-4 w-3/4 bg-gray-200 rounded"></div>
            <div class="h-4 w-1/2 bg-gray-200 rounded"></div>
          </div>
        </div>
        <div class="bg-white rounded-lg shadow-sm p-6 space-y-4">
          <div class="h-6 w-40 bg-gray-200 rounded"></div>
          <div class="space-y-2">
            <div class="h-4 w-full bg-gray-200 rounded"></div>
            <div class="h-4 w-3/4 bg-gray-200 rounded"></div>
            <div class="h-4 w-1/2 bg-gray-200 rounded"></div>
          </div>
        </div>
      </div>

      <!-- 206AB Status and Blacklist Exposure Skeleton -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="bg-white rounded-lg shadow-sm p-6 space-y-4">
          <div class="h-6 w-48 bg-gray-200 rounded"></div>
          <div class="space-y-3">
            <div class="h-4 w-full bg-gray-200 rounded"></div>
            <div class="h-4 w-5/6 bg-gray-200 rounded"></div>
            <div class="h-4 w-4/6 bg-gray-200 rounded"></div>
          </div>
        </div>
        <div class="bg-white rounded-lg shadow-sm p-6 space-y-4">
          <div class="h-6 w-48 bg-gray-200 rounded"></div>
          <div class="space-y-3">
            <div class="h-4 w-full bg-gray-200 rounded"></div>
            <div class="h-4 w-5/6 bg-gray-200 rounded"></div>
            <div class="h-4 w-4/6 bg-gray-200 rounded"></div>
          </div>
        </div>
      </div>

      <!-- Raw Data Analysis Skeleton -->
      <div class="p-8 space-y-10">
        <div class="h-8 w-64 bg-gray-200 rounded mx-auto"></div>
        <div class="space-y-6">
          <div class="h-7 w-56 bg-gray-200 rounded"></div>
          <div class="bg-white rounded-lg shadow-sm p-4 space-y-3">
            <div class="h-4 w-full bg-gray-200 rounded"></div>
            <div class="h-4 w-full bg-gray-200 rounded"></div>
            <div class="h-4 w-full bg-gray-200 rounded"></div>
            <div class="h-4 w-full bg-gray-200 rounded"></div>
            <div class="h-4 w-full bg-gray-200 rounded"></div>
          </div>
        </div>
        <div class="space-y-6">
          <div class="h-7 w-56 bg-gray-200 rounded"></div>
          <div class="bg-white rounded-lg shadow-sm p-4 space-y-3">
            <div class="h-4 w-full bg-gray-200 rounded"></div>
            <div class="h-4 w-full bg-gray-200 rounded"></div>
            <div class="h-4 w-full bg-gray-200 rounded"></div>
            <div class="h-4 w-full bg-gray-200 rounded"></div>
            <div class="h-4 w-full bg-gray-200 rounded"></div>
          </div>
        </div>
        <div class="space-y-6">
          <div class="h-7 w-56 bg-gray-200 rounded"></div>
          <div class="bg-white rounded-lg shadow-sm p-4 space-y-3">
            <div class="h-4 w-full bg-gray-200 rounded"></div>
            <div class="h-4 w-full bg-gray-200 rounded"></div>
            <div class="h-4 w-full bg-gray-200 rounded"></div>
            <div class="h-4 w-full bg-gray-200 rounded"></div>
            <div class="h-4 w-full bg-gray-200 rounded"></div>
          </div>
        </div>
      </div>

      <!-- Footer Skeleton -->
      <div class="bg-white rounded-lg shadow-sm p-6">
        <div class="space-y-2">
          <div class="h-4 w-80 bg-gray-200 rounded mx-auto"></div>
          <div class="h-4 w-64 bg-gray-200 rounded mx-auto"></div>
        </div>
      </div>
    </div>

    <!-- Error State -->
    <div
      *ngIf="error && !loading"
      class="bg-red-50 border border-red-200 rounded-lg p-4 mb-4"
    >
      <p class="text-red-800 font-poppins text-base">{{ error }}</p>
    </div>

    <!-- Content -->
    <div *ngIf="!loading && !error && ngoData" class="space-y-6">
      <!-- Top Header Section -->
      <div class="bg-white rounded-lg shadow-sm p-6">
        <div
          class="flex flex-col md:flex-row justify-start lg:justify-between items-start"
        >
          <div>
            <div class="flex items-center gap-2 mb-2">
              <mat-icon class="text-green-500">check_circle</mat-icon>
              <h3 class="text-lg text-[#0E1116] mb-0">PAN Verification</h3>
            </div>
            <p class="text-sm text-[#4B4B4B]">
              Current PAN:
              <span class="font-medium text-[#0E1116]">{{
                ngoData.pan || "N/A"
              }}</span>
              | Organization:
              <span class="font-medium text-[#0E1116]">{{
                ngoData.confirmedOrganizationName || "N/A"
              }}</span>
            </p>
          </div>
          <div class="flex items-center gap-3">
            <div [matMenuTriggerFor]="menu" class="download-button">
              <app-common-button
                text="Download Report"
                variant="primary"
                type="button"
                color="#44921b"
              />
            </div>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="downloadHTMLReport()">
                HTML Report
              </button>
              <button mat-menu-item (click)="downloadPDFReport()">
                PDF Report
              </button>
            </mat-menu>
            <ng-container *ngIf="!txnId">
              <div data-exclude-from-export="true">
                <app-common-button
                  text="Change PAN"
                  variant="outline"
                  type="button"
                  (onClick)="onChangePAN()"
                />
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <!-- Certificate Banner -->
      <div
        class="bg-gradient-to-r from-[#F58634] to-[#E53935] rounded-lg shadow-sm p-8 text-center"
      >
        <h1 class="text-4xl font-poppins font-bold text-white mb-2">
          NGO Due Diligence Certificate
        </h1>
        <p class="text-lg font-poppins text-white/90">
          Comprehensive Health Report Card & Compliance Assessment
        </p>
      </div>

      <!-- Created Date -->
      <div class="flex items-center gap-2 text-sm font-poppins text-[#4B4B4B]">
        <mat-icon class="text-sm">info</mat-icon>
        <span>Created on: {{ createdDate || "N/A" }}</span>
      </div>

      <!-- Organisation Information Cards -->
      <app-organization-info-card
        [organizationName]="ngoData?.confirmedOrganizationName || ''"
        [pan]="ngoData?.pan || ''"
        [incomeTaxData]="incomeTaxData"
        [darpanMatches]="darpanMatches"
        [csr1]="ngoData?.csr1Data?.value"
      ></app-organization-info-card>

      <!-- Compliance Cards -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <!-- FCRA Compliance -->
        <app-fcra-compliance-card
          [fcraMatches]="fcraMatches"
          [syncDate]="fcraSyncDate"
        ></app-fcra-compliance-card>

        <!-- DARPAN Registration -->
        <app-darpan-compliance-card
          [darpanMatches]="darpanMatches"
          [syncDate]="darpanSyncDate"
        ></app-darpan-compliance-card>

        <!-- Income Tax Exemption Compliance -->
        <app-income-tax-compliance-card
          [incometaxData]="incomeTaxData"
          [syncDate]="incomeTaxSyncDate"
        ></app-income-tax-compliance-card>

        <!-- GST Compliance -->
        <app-gst-compliance-card
          [activeGSTData]="activeGSTData"
          [gstFilingData]="gstFilingData"
          [gstIDS]="gstIDS"
        ></app-gst-compliance-card>
      </div>

      <!-- 206AB Status and Blacklist Exposure -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <!-- 206AB Status -->
        <app-status206ab-card [data]="status206ABData"></app-status206ab-card>

        <!-- Blacklist Exposure -->
        <app-blacklist-exposure-card
          [matches]="blacklistMatches"
          [syncDate]="blacklistSyncDate"
        ></app-blacklist-exposure-card>
      </div>

      <!-- Raw Data Analysis -->
      <div class="p-8 space-y-10">
        <h1
          class="text-center text-3xl font-bold text-red-800 mb-10 font-poppins"
        >
          Raw Data Analysis
        </h1>

        <!-- DARPAN Registration Data -->
        <div *ngIf="darpanMatches.length > 0" class="mb-12">
          <h2
            class="text-2xl text-red-800 mb-6 pb-3 border-b-2 border-orange-400 font-poppins"
          >
            DARPAN Registration Data
          </h2>
          <app-raw-data-table
            [columns]="darpanColumns"
            [data]="darpanTableData"
          ></app-raw-data-table>
        </div>

        <!-- Blacklisted NGO Matches -->
        <div *ngIf="blacklistMatches.length > 0" class="mb-12">
          <h2
            class="text-2xl text-red-800 mb-6 pb-3 border-b-2 border-orange-400 font-poppins"
          >
            Blacklisted NGO Matches
          </h2>
          <app-raw-data-table
            [columns]="blacklistColumns"
            [data]="blacklistTableData"
          ></app-raw-data-table>
        </div>

        <!-- FCRA Registration Data -->
        <div *ngIf="fcraMatches.length > 0" class="mb-12">
          <h2
            class="text-2xl text-red-800 mb-6 pb-3 border-b-2 border-orange-400 font-poppins"
          >
            FCRA Registration Data
          </h2>
          <app-raw-data-table
            [columns]="fcraColumns"
            [data]="fcraTableData"
          ></app-raw-data-table>
        </div>

        <!-- Income Tax Exemption Registration Data -->
        <div *ngIf="incomeTaxRawData.length > 0" class="mb-12">
          <h2
            class="text-2xl text-red-800 mb-6 pb-3 border-b-2 border-orange-400 font-poppins"
          >
            Income Tax Exemption Registration Data
          </h2>
          <app-raw-data-table
            [columns]="incomeTaxColumns"
            [data]="incomeTaxTableData"
          ></app-raw-data-table>
        </div>

        <!-- GST Filing Data by State -->
        <div *ngIf="groupedGSTFilingData.length > 0" class="mb-12">
          <h2
            class="text-2xl text-red-800 mb-6 pb-3 border-b-2 border-orange-400 font-poppins"
          >
            GST Filing Data by State
          </h2>
          <div *ngFor="let group of groupedGSTFilingData" class="mb-8">
            <div
              class="bg-orange-400 text-white p-4 font-poppins font-semibold rounded-t-lg"
            >
              {{ group.state }} - GSTIN: {{ group.gstin }}
            </div>
            <app-raw-data-table
              [columns]="gstFilingColumns"
              [data]="gstFilingData"
            ></app-raw-data-table>
          </div>
        </div>

        <!-- 206AB Status Data -->
        <div class="mb-12" *ngIf="status206ABData">
          <h2
            class="text-2xl text-red-800 mb-6 pb-3 border-b-2 border-orange-400 font-poppins"
          >
            206AB Status Data
          </h2>
          <app-raw-data-table
            [columns]="status206ABColumns"
            [keyValueMode]="true"
            [keyValueData]="status206ABTableData"
          ></app-raw-data-table>
        </div>

        <!-- MCA Section with Disclaimer -->
        <div *ngIf="mcaDocPullEnabled" class="mb-12">
          <!-- MCA Processing Disclaimer -->
          <div
            class="bg-amber-50 border border-amber-300 rounded-lg p-4 flex items-start gap-3 mb-6"
          >
            <mat-icon class="text-amber-600 flex-shrink-0 mt-0.5"
              >schedule</mat-icon
            >
            <div class="flex flex-col gap-1">
              <span class="font-poppins font-semibold text-amber-800 text-sm">
                MCA Data Processing
              </span>
              <p class="font-poppins text-amber-700 text-sm mb-0">
                MCA Document Pull takes approximately
                <strong>36-72 hours</strong> to process. Please check the
                <strong>Report History</strong> later to view the complete
                results.
              </p>
            </div>
          </div>
        </div>

        <div
          *ngIf="mcaData['isCorporatePan'] && mcaData['companyDetails']"
          class="mb-12"
        >
          <h2
            class="text-2xl text-red-800 mb-6 pb-3 border-b-2 border-orange-400 font-poppins"
          >
            Company Basic Details - (From MCA)
          </h2>
          <app-raw-data-table
            [columns]="companyBasicDetailsColumns"
            [keyValueMode]="true"
            [keyValueData]="companyBasicDetailsTableData"
          ></app-raw-data-table>
        </div>

        <div *ngIf="directorSummaryData.length > 0" class="mb-12">
          <h2
            class="text-2xl text-red-800 mb-6 pb-3 border-b-2 border-orange-400 font-poppins"
          >
            Director Summary - (From MCA)
          </h2>
          <app-raw-data-table
            [columns]="directorSummaryColumns"
            [data]="directorSummaryTableData"
          ></app-raw-data-table>
        </div>

        <ng-container *ngIf="directorData.length > 0">
          <div *ngFor="let director of directorDetailsTableData" class="mb-12">
            <h2
              class="text-2xl text-red-800 mb-6 pb-3 border-b-2 border-orange-400 font-poppins"
            >
              Director Details - {{ director["Full Name"] }}
            </h2>
            <app-raw-data-table
              [columns]="directorDetailsColumns"
              [keyValueMode]="true"
              [keyValueData]="director"
            ></app-raw-data-table>
          </div>
        </ng-container>

        <!-- Legal Check Section with Disclaimer -->
        <div *ngIf="legalCheckEnabled" class="mb-12">
          <h2
            class="text-2xl text-red-800 mb-6 pb-3 border-b-2 border-orange-400 font-poppins"
          >
            Legal Check Data
          </h2>
          <!-- Legal Check Processing Disclaimer -->
          <div
            class="bg-blue-50 border border-blue-300 rounded-lg p-4 flex items-start gap-3"
          >
            <mat-icon class="text-blue-600 flex-shrink-0 mt-0.5"
              >schedule</mat-icon
            >
            <div class="flex flex-col gap-1">
              <span class="font-poppins font-semibold text-blue-800 text-sm">
                Legal Check Processing
              </span>
              <p class="font-poppins text-blue-700 text-sm mb-0">
                Legal Check takes approximately <strong>3-4 hours</strong> to
                process. Please check the <strong>Report History</strong> later
                to view the complete results.
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="bg-white rounded-lg shadow-sm p-6">
        <div
          class="flex flex-col justify-center items-center gap-4 text-sm font-poppins text-[#4B4B4B]"
        >
          <div>
            Generated on:
            <span>{{ createdDate || "N/A" }}</span>
            | Powered by Dhwani Rural Information Systems
          </div>
          <div class="flex items-center gap-2">
            <span *ngIf="!txnId">
              Processing Time: {{ processingTime }} |
            </span>
            <span>
              Data Sources:
              {{ ngoData?.dataSources || "6 databases verified" }}</span
            >
          </div>
        </div>
      </div>
    </div>

    <!-- No Data State -->
    <div
      *ngIf="!loading && !error && !ngoData"
      class="bg-white rounded-lg shadow-sm p-6 text-center"
    >
      <p class="text-[#4B4B4B] font-poppins text-base">No data available</p>
    </div>
  </div>
</div>
